import keyMirror from 'keymirror';

const SEAT_CHARACTERISTICS = keyMirror({
  A: null,
  EXIT_ROW: null,
  M: null,
  W: null,
  XW: null,
  DO_NOT_RECLINE: null,
});

export default SEAT_CHARACTERISTICS;
